<ul
  class="notification-menu__list"
  appInfiniteScroll
  [triggerBefore]="100"
  (scrolled)="onScroll()"
>
  <li
    data-testId="notification-item"
    class="layout-topbar-action-item notification-item cursor-pointer"
    *ngFor="let item of cardViewEntries; trackBy: trackByFn"
    [ngClass]="{
      'new-notification': item?.isIncludedInQueryResult,
    }"
    (click)="onclick(item)"
    (keyup.enter)="onclick(item)"
    [attr.aria-hidden]="true"
  >
    <figure
      class="notification-item__icon !inline-flex !justify-center !items-center p-0 m-0"
      [ngClass]="
        miniCardShape?.picture
          | getEntryFieldWrapperClass: 'miniCard' : miniCardConfig.uiAttributes
      "
    >
      <i
        class="text-sm"
        [ngClass]="
          item?.icon
            ? 'mx-0 ' + (item?.icon | getIconCssClass)
            : 'icon icon-perview mx-0'
        "
      ></i>
    </figure>
    <div class="notification-item-container">
      <strong
        class="notification-item__title block whitespace-nowrap overflow-hidden text-ellipsis"
        [ngClass]="
          miniCardShape?.mainTitle
            | getEntryFieldWrapperClass
              : 'miniCard'
              : miniCardConfig.uiAttributes
        "
      >
        {{ item?.mainTitle | propertyTranslator }}
      </strong>
      <p
        class="notification-item__text mb-0 py-1"
        [ngClass]="
          miniCardShape?.subTitle
            | getEntryFieldWrapperClass
              : 'miniCard'
              : miniCardConfig.uiAttributes
        "
      >
        {{ item?.subTitle | propertyTranslator }}
      </p>
      <span
        class="notification-item__date text-muted text-xs"
        [ngClass]="
          miniCardShape?.date
            | getEntryFieldWrapperClass
              : 'miniCard'
              : miniCardConfig.uiAttributes
        "
      >
        {{ item.date | fromNow: dateFormat }}
      </span>
    </div>
  </li>
  <ng-container
    *ngIf="loading && cardViewEntries.length < totalCount"
    [ngTemplateOutlet]="!!cardViewEntries.length ? pageLoad : firstLoad"
  >
  </ng-container>
</ul>

<ng-template #firstLoad>
  <li class="" data-testid="loading-item">
    <ng-container [ngTemplateOutlet]="notificationLoader"></ng-container>
  </li>
  <li class="" data-testid="loading-item">
    <ng-container [ngTemplateOutlet]="notificationLoader"></ng-container>
  </li>
  <li class="" data-testid="loading-item">
    <ng-container [ngTemplateOutlet]="notificationLoader"></ng-container>
  </li>
</ng-template>

<ng-template #pageLoad>
  <li class="" data-testid="loading-item">
    <ng-container [ngTemplateOutlet]="notificationLoader"></ng-container>
  </li>
</ng-template>

<ng-template #notificationLoader>
  <div class="notification-loader">
    <div class="flex notification-loader__header p-4">
      <div>
        <p-skeleton width="54px" height="54px" shape="circle"></p-skeleton>
      </div>
      <div class="pt-2 px-4 notification-loader__description">
        <p-skeleton width="100px" height="10px"></p-skeleton>
        <p-skeleton class="mt-4 block" width="100%" height="10px"></p-skeleton>
        <p-skeleton class="mt-2 block" width="100%" height="10px"></p-skeleton>
      </div>
    </div>
  </div>
</ng-template>
